const SORT_HOOK_ASC = '[js-hook-vacancy-sort-asc]';
const SORT_HOOK_DESC = '[js-hook-vacancy-sort-desc]';
const HIDDEN_CLASS = 'vacancies-overview__sort--hidden';

const SORT_ORDERS = {
    DESC: 'DESC',
    ASC: 'ASC',
};

const reload = true;

class VacancyOveriew {
    constructor(element) {
        this.element = element;
        this.orderButtonAsc = element.querySelector(SORT_HOOK_ASC);
        this.orderButtonDesc = element.querySelector(SORT_HOOK_DESC);

        this.qs = require('qs');

        this.bindEvents();

        this.init();
    }

    /**
     * Bind all events
     */
    bindEvents() {
        this.orderButtonAsc.addEventListener('click', () => this.clickHandler(SORT_ORDERS.DESC));
        this.orderButtonDesc.addEventListener('click', () => this.clickHandler(SORT_ORDERS.ASC));
    }

    clickHandler(order) {
        const currentSearchUrl = window.location.search;
        const queryParams = this.qs.parse(currentSearchUrl, { ignoreQueryPrefix: true });

        queryParams.order_by = 'last_update';
        queryParams.sort_order = order;

        const nextSearchUrl = this.qs.stringify(queryParams);

        if (reload) {
            window.location.search = '?' + nextSearchUrl;
        } else {
            const url = window.location.href.split('?')[0];
            window.history.pushState(null, null, url + '?' + nextSearchUrl);
        }

        this.toggleHidden(order);
    }

    init() {
        const searchUrl = window.location.search;
        const queryParams = this.qs.parse(searchUrl, { ignoreQueryPrefix: true });

        const sortOrder = queryParams.sort_order || 'ASC';

        this.toggleHidden(sortOrder.toUpperCase());
    }

    toggleHidden(order) {
        if (order === SORT_ORDERS.ASC) {
            this.orderButtonAsc.classList.remove(HIDDEN_CLASS);
            this.orderButtonDesc.classList.add(HIDDEN_CLASS);
        } else if (order === SORT_ORDERS.DESC) {
            this.orderButtonAsc.classList.add(HIDDEN_CLASS);
            this.orderButtonDesc.classList.remove(HIDDEN_CLASS);
        }
    }
}

export default VacancyOveriew;
